import { Link } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { authActions } from '_store';
import { loginBackground } from '../../assets/img/'
import {HEULIEZ_Logo_RGB, IVECO_BUS_Logo_RGB_web} from '../../assets/img/partnersLogo/'
import { IVG_Logo_FullBrands_White_BlueDot_Web } from 'assets/img/partnersLogo';
import { useState } from 'react';
import { getIcons } from '_helpers';

export { Login };

function Login() {
    const dispatch = useDispatch();

    // form validation rules 
    const validationSchema = Yup.object().shape({
        username: Yup.string().required('Nom d\'utilisateur requis'),
        password: Yup.string().required('Mot de passe requis')
    });
    const formOptions = { resolver: yupResolver(validationSchema) };

    // get functions to build form with useForm() hook
    const { register, handleSubmit, formState } = useForm(formOptions);
    const { errors, isSubmitting } = formState;

    const [ isPasswordVisible, setIsPasswordVisible ] = useState(false)

    function onSubmit({ username, password }) {
        return dispatch(authActions.login({ username, password }));
    }


    return (
        <div className="login-container" >            
            <div className='login-img-container' style={{backgroundImage: `url(${loginBackground})`}}>
            </div>
            <div className="login-form-container">
                <div className='login-logo-container'>                    
                    <img src={IVECO_BUS_Logo_RGB_web} className="login-logo bordered-logo" alt="logo"/>    
                    <span className='logo-separator'></span>   
                    <img src={HEULIEZ_Logo_RGB} className="login-logo" alt="logo"/>             
                </div>
                <div className="login-title">
                    <h1>Portail Bus Elec</h1>
                </div>
                
                <div className="login-fields">    
                    <form onSubmit={handleSubmit(onSubmit)}>                        
                        <div className="login-input-wrapper">
                            <label className="login-form-label">
                                Utilisateur
                            </label>
                            <span className="login-form-input-logo">
                                <img src={getIcons('permIdentityOutlined')} alt="account"/>
                            </span>
                            <input name="username" type="text" autoComplete="new-password" {...register('username')} className={`form-control ${errors.username ? 'is-invalid' : ''} login-input` } placeholder="Identifiant"/>
                            <div className="invalid-feedback">{errors.username?.message}</div>
                        </div>
                        <div className="login-input-wrapper">  
                            <label className="login-form-label">
                                Mot de passe  
                            </label>    
                            <span className="login-form-input-logo">
                                <img src={getIcons('lockOutlined')} alt="password"/>
                            </span>
                            <input name="password" type={isPasswordVisible ? 'text' : 'password'} autoComplete="new-password" {...register('password')} className={`form-control ${errors.password ? 'is-invalid' : ''} login-input`} placeholder="Mot de passe"/>
                            <span className="show-password-icon top-1/2">
                                <button 
                                    type="button" 
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setIsPasswordVisible(!isPasswordVisible);
                                    }} 
                                    
                                    >
                                    <img src={isPasswordVisible ? getIcons('visibilityOffOutlined') : getIcons('visibilityOutlined')} height={24} width={24} alt='icone oeil'/>
                                </button>
                            </span>
                            <div className="invalid-feedback">{errors.password?.message}</div>
                        </div>
                        <Link to="/reset_password" className="login-forgotten-password">Mot de passe oublié ?</Link>
                        <button disabled={isSubmitting} className="btn btn-primary login-form-submit">
                            {isSubmitting && <span className="spinner-border spinner-border-sm me-1"><img src={getIcons('fileDownloadOutlined')} alt="login"/></span>}
                            Se connecter
                        </button>                    
                    </form>                    
                </div>                
            </div>
            <div className={"login-footer"} id={"login-footer"}>
                <img src={IVG_Logo_FullBrands_White_BlueDot_Web} alt={'logo_full_brand'} className={"login-footer-icon"} />
            </div>
        </div>
    )
}
